import {
  Apollo_gql,
  GraphMutationBuilderPayload,
  GraphMutationPayload,
  createMutation,
} from '@ta/server';
import { userProfileProps } from '@ta/user';

import { identityVerificationPayloadProps } from './dto/identity-verification-payload';
import { ownerProps } from './dto/owner';
import { tenantProps } from './dto/tenant';
import { UpdateOwnerInput } from './form/dto/updateOwnerInput';
import { UpdateTenantInput } from './form/dto/updateTenantInput';
import { UpdateUserInput } from './form/dto/updateUserInput';

/** Mise à jour partielle (flags de notification…) : un seul argument, donc le builder suffit. */
export function updateUserPartial(input: Partial<UpdateUserInput>): GraphMutationBuilderPayload {
  return createMutation('updateUser', {
    argument: 'input',
    props: userProfileProps.get('id'),
    type: 'UpdateUserInput!',
    value: input,
  });
}

export function updateUser(user: Partial<UpdateUserInput>): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation UpdateUser($user: UpdateUserInput!) {
        updateUser(input: $user) {
            ${userProfileProps.get('id')}
        }
      }
    `,
    variables: {
      user,
    },
  };
}

export function updateTenant(tenant: Partial<UpdateTenantInput>): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation UpdateTenant($tenant: UpdateTenantInput!) {
        updateTenant(input: $tenant) {
            ${tenantProps.get('id')}
        }
      }
    `,
    variables: {
      tenant,
    },
  };
}

export function updateOwner(owner: Partial<UpdateOwnerInput>): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation UpdateOwner($owner: UpdateOwnerInput!) {
        updateOwner(input: $owner) {
            ${ownerProps.get('id')}
        }
      }
    `,
    variables: {
      owner,
    },
  };
}

export function createTenantLink(): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation CreateTenantLink {
        createTenantLink {
            ${tenantProps.get('id')}
        }
      }
    `,
    variables: {},
  };
}
export function createOwnerLink(): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation CreateOwnerLink {
        createOwnerLink {
            ${tenantProps.get('id')}
        }
      }
    `,
    variables: {},
  };
}

export function deleteTenantLink(): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation DeleteTenantLink {
        deleteTenantLink {
            ${tenantProps.get('id')}
        }
      }
    `,
    variables: {},
  };
}
export function deleteOwnerLink(): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation DeleteOwnerLink {
        deleteOwnerLink {
            ${tenantProps.get('id')}
        }
      }
    `,
    variables: {},
  };
}

export function initiateIdentityVerification(lang?: string): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation InitiateIdentityVerification($input: InitiateIdentityVerificationInput!) {
        initiateIdentityVerification(input: $input) {
          ${identityVerificationPayloadProps.get('redirectUrl')}
          ${identityVerificationPayloadProps.get('verificationId')}
        }
      }
    `,
    variables: { input: { lang } },
  };
}
